module.exports = __webpack_public_path__ + "static/media/15.4bafe8f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryPage/images/biquad/15.png
// module id = 1536
// module chunks = 0